export default __webpack_public_path__ + "img/b241514fffe0044b3b76de8314f03abd.svg";